import reducer from './reducers';
import * as patientAnalysesActions from './actions';
import * as patientAnalysesSelectors from './selectors';

export { patientAnalysesActions, patientAnalysesSelectors };
export default reducer;
